// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx

// TODO: Check if the icon is alined properly.
// If it is not: Replace/extend defaultAlignedActionIconGroupProps to make it look right.
// https://stash.int.klarna.net/projects/UI/repos/bubble-ui/pull-requests/121/overview?commentId=2244923
import { baseActionIcon } from '@bubble-ui/temp-action-icon-base';
import { isWaffle, isWhiteLabel } from '@bubble-ui/particle-design-versions';
var ActionIconChevronRightPathPancake = 'm8.677 6.605-4 5.133L3.1 10.509l3.52-4.518L3.1 1.48 4.677.25l4 5.126a.998.998 0 0 1 0 1.229Z';
var ActionIconChevronRightPathWaffle = 'm4.554 11.678-1.108-.856c1.639-2.12 3.548-3.951 4.499-4.82-.953-.864-2.862-2.689-4.5-4.826l1.11-.852c2.147 2.8 4.87 5.119 4.898 5.142a.7.7 0 0 1 .002 1.066c-.027.023-2.752 2.365-4.901 5.146Z';
var ActionIconChevronRightPathWaffleFilled = 'm4.554 11.678-1.108-.856c1.639-2.12 3.548-3.951 4.499-4.82-.953-.864-2.862-2.689-4.5-4.826l1.11-.852c2.147 2.8 4.87 5.119 4.898 5.142a.7.7 0 0 1 .002 1.066c-.027.023-2.752 2.365-4.901 5.146Z';
var ActionIconChevronRightPathWhiteLabel = 'm4.265 10.53-1.06-1.06L6.674 6l-3.47-3.47 1.06-1.06L8.795 6l-4.53 4.53Z';
var ActionIconChevronRightPathWhiteLabelFilled = 'm4.265 10.53-1.06-1.06L6.674 6l-3.47-3.47 1.06-1.06L8.795 6l-4.53 4.53Z';
export var ActionIconChevronRight = baseActionIcon('ActionIconChevronRight', {
  getPath: _ref => {
    var {
      designVersion,
      filled
    } = _ref;
    return isWhiteLabel(designVersion) ? filled ? ActionIconChevronRightPathWhiteLabelFilled : ActionIconChevronRightPathWhiteLabel : isWaffle(designVersion) ? filled ? ActionIconChevronRightPathWaffleFilled : ActionIconChevronRightPathWaffle : ActionIconChevronRightPathPancake;
  }
});
//# sourceMappingURL=index.js.map